import React from 'react'
import { useNavigate } from 'react-router'
import LeftMenu from '../AnalyticsModule/Left'
import { deepOrange, lime, teal, amber, blue, grey, lightBlue, orange, pink, purple, yellow } from '@mui/material/colors';

const EnableDisableDashboard = () => {
    const navigate = useNavigate()
    const role = localStorage?.userrole
  return (
   <>
 <LeftMenu>
 <div className="container pl-0 reports">
        <div className="row">
          <div class="col-md-6">
             <div class="card " style={{background:teal[100],border:`1px solid ${teal[800]}`}}>
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate(`/${role}/enable_disable/ballot_verfication`)}>
                <div class="card-icon card-icon-large"><i className="fas fa-solid fa-qrcode mr-3"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment">
                    <h5 class="d-flex align-items-center mb-0">
                      Ballot Verification Flag
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div class="col-md-6">
            <div class="card l-bg-orange-dark">
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate(`/${role}/enable_disable/no_voter_marked`)}>
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-users-viewfinder mr-3"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment">
                    <h5 class="d-flex align-items-center mb-0">
                    ACs With No Service Voter
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
             <div class="col-md-6">
             <div class="card " style={{background:blue[100],border:`1px solid ${blue[800]}`}}>
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate(`/${role}/enable_disable/scanning_completed`)}>
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-signal mr-3"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment">
                    <h5 class="d-flex align-items-center mb-0">
                    ACs With Scanning Completed
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          {/* <div className='row'>
       
          </div> */}
          </div>
 </LeftMenu>
   </>
  )
}

export default EnableDisableDashboard